// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2NZNu","colMaxWidth":"Table_colMaxWidth__3-s8T"};